module.exports = __webpack_public_path__ + "img/logo-internal.a84a59de.svg";